/**
 * @file URL input type - extends String with url input type
 * @version 1.0.0
 */

import { StringInputType } from './string.js';

export const UrlInputType = {
  name: 'url',
  matches: getAttribute => getAttribute('format') === 'url',
  displayComponent: StringInputType.displayComponent,
  editComponent: {
    name: 'UrlEdit',
    extends: StringInputType.editComponent,
    methods: {
      getInputType() {
        return 'url';
      },
    },
  },
};

export default UrlInputType;
